import React, { useMemo } from "react";

import { useIntl } from "react-intl";

import { EntitiesSupportedByEmailFeature } from "@mapmycustomers/shared/types/entity";

import SelectField from "@app/component/input/SelectField";
import getRecipientDisplayName from "@app/util/email/getRecipientDisplayName";

import styles from "./EmailRecipientSelect.module.scss";

interface EmailRecipientSelectProps {
  disabled?: boolean;
  onChange?: (id?: EntitiesSupportedByEmailFeature["id"]) => void;
  recipients: EntitiesSupportedByEmailFeature[];
  value?: EntitiesSupportedByEmailFeature["id"];
}

const EmailRecipientSelect = ({
  disabled,
  onChange,
  recipients,
  value,
}: EmailRecipientSelectProps) => {
  const intl = useIntl();
  const recipientOptions = useMemo(
    () =>
      recipients.map((recipient) => ({
        label: getRecipientDisplayName(recipient),
        value: recipient.id,
      })),
    [recipients]
  );

  return (
    <SelectField<EntitiesSupportedByEmailFeature["id"]>
      className={styles.container}
      disabled={disabled}
      dropdownMatchSelectWidth={false}
      onChange={onChange}
      options={recipientOptions}
      placeholder={intl.formatMessage({
        id: "email.recipientSelect.placeholder",
        defaultMessage: "Select recipient to simulate",
        description: "email creation modal - Select Recipient",
      })}
      value={value}
    />
  );
};

export default EmailRecipientSelect;
